import { ApiAccountDashboardStrategy } from 'api/rtk-api'
import {
  ConstantProportionLeverageModal,
  ContinuousProtectionModal,
  RiskManagedModal,
  TermProtectionModal,
  VolControlModal
} from 'components/core-v2'
import { ApiStrategyName } from 'types/api/account/api-strategy-name'

const MODAL_MAP: Record<ApiStrategyName, any> = {
  'Continuous Protection': ContinuousProtectionModal,
  'Term Protection': TermProtectionModal,
  'Constant Proportion Leverage': ConstantProportionLeverageModal,
  'Delta 1': null,
  'Volatility Control Leverage': VolControlModal,
  'Risk Managed': RiskManagedModal
}

export const formatData = (strategies: ApiAccountDashboardStrategy[]) =>
  strategies.map(strategy => ({
    parent: '0',
    // This is a temporary measure due to Dominion trades not having a portfolio id or name
    name: strategy.strategyName || 'Continuous Protection (Dominion)',
    id: strategy.strategyName,
    count: strategy.numberOfActiveAccounts,
    value: strategy.zarValue,
    ModalComponent: MODAL_MAP[strategy.strategyName]
  }))
